import { isLiveProgram, isPastProgram } from './getProgramProperties';
import { RhinoProgram } from './type';

// since programs are sorted by start date we can kick in binary search
export function searchLiveProgram(
  programs: RhinoProgram[],
  start = 0,
  end = programs.length - 1,
): RhinoProgram | undefined {
  if (start > end) {
    return undefined;
  }

  const middle = Math.floor((start + end) / 2);
  const middleProgram = programs[middle];

  if (!middleProgram) {
    return undefined;
  }

  if (isLiveProgram(middleProgram)) {
    return middleProgram;
  }

  return isPastProgram(middleProgram)
    ? searchLiveProgram(programs, middle + 1, end)
    : searchLiveProgram(programs, start, middle - 1);
}
